<template>


<div>
  <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show" :timeout="1000" top>
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage"></loading>
        <div id="subi">
  <!-- <h1>Vue Select</h1> -->
  <v-select :options="subitemlist" v-model="subitem" placeholder="Choose Subcategory"></v-select>
  
</div>
         <!-- <b-input-group  >
    <b-form-input  type="text" v-model="subitem" list="subi" placeholder="Choose Subcategory"></b-form-input>
    <b-input-group-append>
      <b-button variant="outline-success" @click="clearitem">  <v-icon style="color: red;">mdi-backspace</v-icon></b-button>
     
    </b-input-group-append>
    <datalist id="subi">
    <option  v-for="(subitm, i) in subitemlist" :key="i">{{subitm}}</option>
  </datalist>
  
  </b-input-group>
       -->

         <!-- <b-input-group  >
    <b-form-input  type="text" v-model="search" autofocus placeholder="Search items"></b-form-input>
    <b-input-group-append>
      <b-button variant="outline-success" @click="searchItem">  <v-icon>mdi-magnify</v-icon></b-button>
     
    </b-input-group-append>
  </b-input-group> -->
<v-container class="grey lighten-5">
    
    <v-row dense
    >
    
    <v-col
    
          v-for="(item, i) in scrollproducts"
          :key="i"
          cols="6"
        >
       
     <v-card  light style="color:grey" >
       <div id="titl" style="background: #f0f0f0;">
          <b style="font-size: 10px;"
                  class="headline cs"
                > {{item.ItemName}}</b><br>
                <b style="font-size: 10px;"
                  class="headline cs"
               > {{item.ArabicName}}</b>
       </div>
       <div @click="openitem(item.Barcode,item,i)">
            <v-avatar
                class="ma-3"
                size="125"
                tile
              >
                <v-img :src="imgURL+item.ItemCode+'.jpg'" :id="item.Barcode"  @error="setAltImg(item.Barcode)" :alt="item.ItemCode+'.jpg'" ></v-img>
               
              </v-avatar>
               <v-card-title style="color: #ffc107;"
                  class="headline"
                 
                >₹{{ formatPrice(item.SellingRate) }}</v-card-title>
       </div>
    <v-row no-gutters>
      <v-col cols="4" :id="item.SellingRate"  @click="addwishlist(item.ItemName,i,item.Barcode)" >
        <v-btn icon >
          <v-icon :id="item.Barcode+item.ItemName">mdi-heart</v-icon>
        </v-btn>
      </v-col>
      <v-col class="4" :id="item.SellingRate"  @click="adcart(item.ItemName,i,item.Barcode,item.ArabicName)">
              <v-btn icon  >
                <v-icon :id="item.Barcode+item.ArabicName">mdi-cart</v-icon>
                
              </v-btn>
      </v-col>
    
      <v-col class="4">
              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
     </v-col>
    </v-row>
     </v-card>
    </v-col>
      
     
         
       
    </v-row>
  </v-container>
 

  </div>
</template>

<script>

import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.component('v-select', vSelect)


  export default {
    components: {
            Loading,
           
             vSelect

        },
    data: () => ({
      opt:['Canada', 'United States','Afghanistan','Albania','Algeria','Andorra','Angola'],
        a:'',
        cat:'',
       subitem:'',
      subitemlist:[],
      imgURL:'',
      isLoading: false,
      fullPage: true,
      scrolledToBottom: 1,
      products : [],
      scrollproducts : [],
      seen :true,
      seenid:'',
      cartlist:[],
      wishlist:[],
      text: '',
      states: [
          { name: 'Florida', abbr: 'FL', id: 1 },
          { name: 'Georgia', abbr: 'GA', id: 2 },
          { name: 'Nebraska', abbr: 'NE', id: 3 },
          { name: 'California', abbr: 'CA', id: 4 },
          { name: 'New York', abbr: 'NY', id: 5 },
        ],
      timeout: 1500,
      scrcount : 1,
      colorcount:0,
      categoryName:'',
      cartitem:[],
      wishitem:[],
      test:[],
      firstload:'',
      myArray:[],//using for remove/add to cart while toggle click
      loopcart:'',
      snackbar: {
                show: false,
                message: null,
                color: null
            },
      clicked: [],
       wishclicked: [],
      cartcolorbar:[],
      items: [
        ],
    }),

    watch: {
    scrcount: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
     this.getscrollItems();
    },
    subitem: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
     this.getscrollsearchItems();
    }
    },

    mounted() {
    this.categoryName = localStorage.getItem("catName");
   
   
    this.imgURL = localStorage.getItem("imgUrl");

     this.test = JSON.parse(localStorage.getItem("cartlist"));
     this.decimalPlaces=localStorage.getItem("decimalPlaces");
    
    
    //  this.getcategories();
    this.Subcategories();
     this.getPrimaryCurrency();
     this.getscrollItems();
     this.scrollbody();
     this.getcategories();

    this.$parent.$children[0].$parent.$parent.itemcountnumber = localStorage.getItem('countitemno');
    
    
    },
    methods: {

        formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      setAltImg(bar) { 
        
          this.urlimg = "url("+this.imgURL+"ItemImage.jpg)";
       console.log("aa "+this.urlimg)
         document.getElementById(bar).style.backgroundImage = this.urlimg
         document.getElementById(bar).style.backgroundPosition = "center center";
          document.getElementById(bar).style.backgroundSize = "cover"
       
     }, 
     

      setcartcolor: function(){
           if(localStorage.getItem("carclicked")!== null)
    {
      
      this.loopcart = JSON.parse(localStorage.getItem("carclicked"));
      

      for(this.i=0;this.i<this.loopcart.length; this.i++)
        {

          console.log("ok"+this.loopcart[this.i])
          
          this.var = this.loopcart[this.i]

          document.getElementById(this.loopcart[this.i]).style.color = '#009900';
            
          
        
        }
    }
     if(localStorage.getItem("wishclicked")!== null)
     {
         this.loopwish = JSON.parse(localStorage.getItem("wishclicked"));
      

        for(this.i=0;this.i<this.loopwish.length; this.i++)
        {
          
          this.var = this.loopwish[this.i]
          document.getElementById(this.loopwish[this.i]).style.color = 'red';
           
        }
     
    }
      },
      clearitem(){
this.subitem = ''
      },
        getcategories: function ()      {

      axios.get(this.$bURL+"item/GetItemCategories")
      .then((response)  =>  {
        // this.loading = false;
        // this.categories = response.data;
           console.log(response)
      }, (error)  =>  {
          console.log(error)
      })

     },
       Subcategories: function ()      {

      axios.get(this.$bURL+"item/GetItemSubCategories?Category="+this.categoryName)
      .then((response)  =>  {
        // this.loading = false;
        this.subitemlist = response.data;
           console.log("subitemlist"+ response.data)
      }, (error)  =>  {
          console.log(error)
      })

     },
     
    


      openitem : function(brcd,item,pos)
      {
          
          Router.push('/singleitem');
          localStorage.setItem("barcode", brcd);
          localStorage.setItem("pos", pos);
           localStorage.setItem("singleviewfullitem", JSON.stringify(item));
         
      },
      scrollbody()
      {
    window.onscroll = () => {
     if (Math.round(document.documentElement.scrollTop + window.innerHeight) == document.documentElement.offsetHeight) {
        this.scrcount +=1;
      }
    };



    
      },
      //------------------------------------------
 getPrimaryCurrency: function () {
      axios.get(this.$bURL+"Currency/GetPrimaryCurrency")
      .then((response)  =>  {
        console.log(response.data.DecimalPlaces)
        localStorage.setItem('decimalPlaces', response.data.DecimalPlaces);
        setTimeout(() => {
                  this.isLoading = false
         },1000)
      }, (error)  =>  {
          console.log(error)
      })
    },

///-----------------------------
  
    
     
//get item by scroll count

    getscrollItems: function () {
       this.isLoading = true;
      // this.loading = true;
      if(this.subitem == '')
      {
          this.a ="All"
      }else{
          this.a = this.subitem
      }
      
    //    axios.get(this.$bURL+"item/GetFMCGList?PageNumber="+this.scrcount)
      axios.get(this.$bURL+"item/GetItemDetailsList?Category="+this.categoryName+"&SubCategory="+this.a+"&PageNumber="+this.scrcount)
      .then((response)  =>  {
        // this.loading = false;
        //console.log(response.data)
        this.scrollproducts = this.scrollproducts.concat(response.data);
        setTimeout(this.setcartcolor, 1000)
        setTimeout(() => {
                  this.isLoading = false
                  
         },4000)
      }, (error)  =>  {
          console.log(error)
      })
    },
     getscrollsearchItems: function () {
       this.isLoading = true;
      // this.loading = true;
      if(this.subitem == '')
      {
          this.a ="All"
      }else{
          this.a = this.subitem
      }
      
    //    axios.get(this.$bURL+"item/GetFMCGList?PageNumber="+this.scrcount)
      axios.get(this.$bURL+"item/GetItemDetailsList?Category="+this.categoryName+"&SubCategory="+this.a+"&PageNumber="+this.scrcount)
      .then((response)  =>  {
        // this.loading = false;
        //console.log(response.data)
        this.scrollproducts = response.data;
        setTimeout(this.setcartcolor, 1000)
        setTimeout(() => {
                  this.isLoading = false
                  
         },4000)
      }, (error)  =>  {
          console.log(error)
      })
    },


//--------------------------------------

   //cart Adding Function
   adcart: function (name,pos,bar,arb) {

     if (localStorage.getItem("carclicked") === null) {
  
      this.clicked.push(bar+arb)
     localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       }else{
            this.clicked = JSON.parse(localStorage.getItem("carclicked"))
         this.clicked.push(bar+arb)
          localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       
       }


     
     console.log("id "+ name+" pos "+pos)
      document.getElementById(bar+arb).style.color = '#009900';
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          //  document.getElementById("6950086683397").style.color = '#009900';
    //       alert("already there");
          
    //     }else{
      this.cart =JSON.parse(localStorage.getItem("cartlist"))
      if(this.cart!=null || this.cart!=undefined)
      {
            this.cartlist = this.cart;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.cartlist!=null || this.cartlist!=undefined)
       {
          for(this.i=0;this.i<this.cartlist.length;this.i++)
           {
             if( this.cartlist[this.i].Barcode===this.scrollproducts[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.cartlist[this.flagid].count);
             this.cartlist[this.flagid].count+=1
           }
           else{
             this.scrollproducts[pos].count=1;
             this.cartlist.push(this.scrollproducts[pos]);
           }
       }
      else {
          this.cartlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.cartitem = this.cartlist;
           this.$parent.$children[0].$parent.$parent.addedcartitem = this.cartlist;
        localStorage.setItem("cartlistarray",JSON.stringify(this.cartlist))
        localStorage.setItem("cartcount",this.cartlist.length)
         this.$parent.$children[0].$parent.$parent.itemcountnumber = this.cartlist.length;
        localStorage.setItem("cartlist", JSON.stringify(this.cartlist));

        this.snackbar = {
                        message: 'Item Added Successfully',
                        color: 'success',
                        show: true
                    }
        // }
      

     
   
    },
    //wishlist adding function
     addwishlist: function (name,pos,bar) {




    
    //  console.log("id "+ name+" pos "+pos)
     
     
    
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          
    //       alert("already there");
          
    //     }else{
      this.wish =JSON.parse(localStorage.getItem("wishlist"))
      if(this.wish!=null || this.wish!=undefined)
      {
            this.wishlist = this.wish;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.wishlist!=null || this.wishlist!=undefined)
       {
          for(this.i=0;this.i<this.wishlist.length;this.i++)
           {
             if( this.wishlist[this.i].Barcode===this.scrollproducts[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.wishlist[this.flagid].count);
             this.wishlist[this.flagid].count+=1
           }
           else{
             this.scrollproducts[pos].count=1;
             this.wishlist.push(this.scrollproducts[pos]);
           }
       }
      else {
          this.wishlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.wishitem = this.wishlist;
if (localStorage.getItem("wishclicked") !== null) {
          this.wishdata = localStorage.getItem("wishclicked");
          this.n =  this.wishdata.includes(bar+name);
          this.myArray = JSON.parse(localStorage.getItem("wishlist"));
}else
{
  this.n = false
}
// console.log(this.n)

          if(this.n){
             this.wishdata = JSON.parse(localStorage.getItem("wishclicked"));
              document.getElementById(bar+name).style.color = 'grey';
               this.index = this.wishdata.indexOf(bar+name);
               console.log(this.index)

               this.wishdata.splice(this.index,1); 
              console.log(JSON.stringify(this.wishdata));
              // this.arr = this.wishdata.filter(e => e !== bar+name); // will return ['A', 'C']
               localStorage.setItem("wishclicked",JSON.stringify(this.wishdata))
                this.myArray.splice(this.index,1);
               localStorage.setItem("wishlist", JSON.stringify(this.myArray));
  
          }else{
             document.getElementById(bar+name).style.color = 'red';
            if (localStorage.getItem("wishclicked") === null) {
  
        this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
    
       }else{
            this.wishclicked = JSON.parse(localStorage.getItem("wishclicked"))
          this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
       
       }
        
        localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

          }

       

       
      

     
   
    },
    
  
  
  
    }
    


}
</script>
<style scoped>
.v-card__title {
    align-items: center;
    display: block ;
}
.cs{
  padding-left: 5px;
  padding-right: 5px;
   display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; 
}
.v-snack__wrapper {
    align-items: center;
    background-color: #28a745 !important;
    border-radius: 25px;
}
.v-snack .v-snack--active{
 background-color: #28a745 !important;
}
.snackbar{
  background-color:black;
}
#subi {
  max-width: 30em;
  margin: .5em auto;
  border-color: #28a745;
}
</style>